export type SynopsisSection = {
  key: string;
  label: string;
  value: string;
};

const SYNOPSIS_LABELS: Record<string, string> = {
  "email subject": "Email subject",
  "triage summary": "Triage summary",
  "extraction confidence": "Extraction confidence"
};

const SYNOPSIS_MARKER_PATTERN = /(Email subject|Triage summary|Extraction confidence):/gi;

export function synopsisSections(raw: string | null | undefined): SynopsisSection[] {
  const text = (raw ?? "").replace(/\s+/g, " ").trim();
  if (!text) {
    return [];
  }

  const matches = [...text.matchAll(SYNOPSIS_MARKER_PATTERN)];
  if (matches.length === 0) {
    return [{ key: "summary", label: "Summary", value: text }];
  }

  const sections: SynopsisSection[] = [];
  const prefix = text.slice(0, matches[0].index ?? 0).trim();
  if (prefix) {
    sections.push({ key: "summary", label: "Summary", value: prefix });
  }

  for (const [index, match] of matches.entries()) {
    const start = (match.index ?? 0) + match[0].length;
    const end = index + 1 < matches.length ? matches[index + 1].index ?? text.length : text.length;
    const labelKey = match[1].toLowerCase();
    const label = SYNOPSIS_LABELS[labelKey] ?? match[1];
    const value = text.slice(start, end).trim();
    if (value) {
      sections.push({ key: labelKey.replace(/\s+/g, "-"), label, value });
    }
  }

  return sections.length > 0 ? sections : [{ key: "summary", label: "Summary", value: text }];
}

export function synopsisSectionValue(sections: SynopsisSection[], key: string): string | null {
  return sections.find((section) => section.key === key)?.value ?? null;
}
